import { Role, SHINSEISHA_LIST, SHONINSHA_LIST } from "./role.constant";

const allAuthenticated = null;
const allShoninsha = SHONINSHA_LIST;
const allShinseisha = SHINSEISHA_LIST;
const shoninshaAndShinseishaKannri = [...SHONINSHA_LIST, Role.ShinseishaKanri];
const shinseishaKanri = [Role.ShinseishaKanri];
const shinseishaIppan = [Role.ShinseishaIppan];
const shoninshaKanri = [Role.ShoninshaKanri];
const shoninshaIppan = [Role.ShoninshaIppan];

// 画面権限
export const VIEW_ACCESS = {
  shoninshaView: allShoninsha, //承認者
  shinseishaView: allAuthenticated, //申請者
  kaishaView: allShoninsha, //会社
  kaishaGroupView: allAuthenticated, //会社グループ
  maintainView: allShoninsha, //業種分類、申請分類
  settingView: allShoninsha, //設定変更画面
  shinseiView: allAuthenticated, //申請
};

// 画面要素権限
export const ELEMENT_ACCESS = {
  // 申請者
  shinseishaAdd: shoninshaAndShinseishaKannri, //新規登録button
  shinseishaEditAndDelete: shoninshaAndShinseishaKannri, //修正,削除bbutton
  shinseishaExcel: shoninshaAndShinseishaKannri, //エクセル出力button
  shinseishaKaishaNmInput: allShoninsha, //会社名input

  // 会社グループ
  kaishaGroupAdd: allShoninsha, //新規登録button
  kaishaGroupEdit: allShoninsha, //修正button
  kaishaGroupKaishaNmInput: allShoninsha, //会社名input

  // 申請一覧画面
  shinseiKaishaNmInput: allShoninsha, //会社名input
  shinseiShinchokuShoninInput: allShoninsha, //企業内進捗（承認）input
  shinseiShinchokuShinseiInput: allShinseisha, //企業内進捗（申請）input
  shinseiAddShinseiBtn: allShinseisha, //新規申請button
  shinseiExcelBtn: shoninshaAndShinseishaKannri, //excel出力button

  // 申請詳細画面
  shinseiShinchokuShinseiText: allShinseisha, //企業内進捗（承認）text
  shinseiShinchokuShoninText: allShoninsha, //企業内進捗（承認）text

  shinseishaButtons: allShinseisha, //申請者用すべてのボタン
  shoninshaButtons: allShoninsha, //承認者用すべてのボタン

  shinseiButton: shinseishaKanri, //申請ボタン
  shoninButton: shoninshaKanri, //承認ボタン

  shinseiBunruiList: allShoninsha, //ultmarcコメント欄の申請分類名項目
};
